module.exports = __webpack_public_path__ + "img/dsj.c7cbb520.png";